var render = function render(){var _vm=this,_c=_vm._self._c;return _c('document-link',{staticClass:"pretty-outing-link has-hover-background",attrs:{"document":_vm.outing}},[_c('pretty-outing',{attrs:{"outing":_vm.outing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }